import { styled } from '@linaria/react'

import {
  FontSizeREM,
  type DivStyledProps,
  type FlexStyledProps,
  type TextStyledProps,
} from '../types'

export const P = styled.p<TextStyledProps>`
  font-size: ${(props): string => props.fontSize || FontSizeREM.PX16};
  line-height: ${(props): string => props.lineHeight || FontSizeREM.PX18};
  font-weight: ${(props): string => String(props.fontWeight || `600`)};
  font-family: ${(props): string => props.fontFamily || 'Inter'};
  text-align: ${(props): string => props.textAlign || 'unset'};
`

export const PSmall = styled(P)`
  max-width: ${(props): string => props.maxWidth || 'unset'};
  font-size: ${(props): string => props.fontSize || FontSizeREM.PX14};
  line-height: ${(props): string => props.lineHeight || FontSizeREM.PX18};
  font-weight: ${(props): string => String(props.fontWeight || `400`)};
`

export const PSmallBold = styled(PSmall)`
  font-weight: 700;
`

export const PBlack = styled(P)`
  color: ${(props): string => (props.disabled ? 'var(--gray300)' : 'var(--gray500)')};
`

export const PSmallGray = styled(PSmall)`
  color: ${(props): string => (props.disabled ? 'var(--gray200)' : 'var(--gray400)')};
`

export const Small = styled.small<TextStyledProps>`
  display: block;
  font-weight: ${(props): string => String(props.bold ? '700' : `400`)};
  margin: ${(props): string => props.margin || 'unset'};
`

export const Span = styled.span<{
  color?: string
  lineHeight?: string
  fontSize?: string
  fontWeight?: number
}>`
  color: ${(props): string => props.color || 'var(--gray500)'};
  font-size: ${(props): string => props.fontSize || FontSizeREM.PX16};
  line-height: ${(props): string => props.lineHeight || FontSizeREM.PX16};
  font-weight: ${(props): string => String(props.fontWeight || `400`)};
`

export const H1 = styled.h1<TextStyledProps>`
  margin: ${(props): string => props.margin || '0 0 12px'};
`

export const H3 = styled.h3<TextStyledProps>`
  margin: ${(props): string => props.margin || '0 0 8px'};
`

export const Div = styled.div<DivStyledProps>`
  position: ${(props): string => props.position || 'unset'};
  top: ${(props): string => props.top || 'unset'};
  left: ${(props): string => props.left || 'unset'};
  bottom: ${(props): string => props.bottom || 'unset'};
  right: ${(props): string => props.right || 'unset'};
  height: ${(props): string => props.height || 'unset'};
  width: ${(props): string => props.width || 'unset'};
  margin: ${(props): string => props.margin || '0'};
  background-color: ${(props): string => props.backgroundColor || 'unset'};
  transform: ${(props): string => props.transform || 'unset'};
  overflow-y: ${(props): string => props.overflowY || 'unset'};
  overflow-x: ${(props): string => props.overflowX || 'unset'};
  z-index: ${(props): string => String(props.zIndex || 'unset')};
  border-radius: ${(props): string => props.borderRadius || 'unset'};
`

export const EditButton = styled.span<TextStyledProps>`
  position: ${(props): string => props.position || 'unset'};
  top: ${(props): string => props.top || 'unset'};
  left: ${(props): string => props.left || 'unset'};
  bottom: ${(props): string => props.bottom || 'unset'};
  right: ${(props): string => props.right || 'unset'};
  color: ${(props): string => props.color || 'var(--primary500)'};
  font-size: ${(props): string => props.fontSize || FontSizeREM.PX16};
  line-height: ${(props): string => props.lineHeight || FontSizeREM.PX18};
  font-weight: ${(props): string => String(props.fontWeight || `700`)};
`

export const Flex = styled.div<FlexStyledProps>`
  display: flex;
  flex-direction: ${(props): string => props.flexDirection || 'column'};
  justify-content: ${(props): string => props.justifyContent || 'unset'};
  align-items: ${(props): string => props.alignItems || 'unset'};
  height: ${(props): string => props.height || 'unset'};
  width: ${(props): string => props.width || 'unset'};
  margin: ${(props): string => props.margin || 'unset'};
  overflow-y: ${(props): string => props.overflowY || 'unset'};
  overflow-x: ${(props): string => props.overflowX || 'unset'};
  background-color: ${(props): string => props.backgroundColor || 'unset'};
  color: ${(props): string => props.color || 'unset'};
  padding: ${(props): string => props.padding || 'unset'};
  border-radius: ${(props): string => props.borderRadius || 'unset'};
  gap: ${(props): string => props.gap || 'unset'};
`

export const ErrorMessage = styled.div`
  height: 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: 'var(--error500)';
`

export const InfoMessage = styled.div<{ color?: string }>`
  height: 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${(props): string => props.color || 'var(--gray400)'};
`
